import firebase from "firebase/compat/app";
import "firebase/compat/app-check";
import "firebase/compat/auth";
import "firebase/compat/firestore";

import config from "../config";

let appCheckActivated = false;

export function isFirebaseConfigured() {
  const { apiKey, authDomain, projectId, appId } = config.firebase;
  return Boolean(apiKey && authDomain && projectId && appId);
}

function activateAppCheck() {
  if (!config.appCheck.siteKey || appCheckActivated) {
    return;
  }

  try {
    firebase.appCheck().activate(config.appCheck.siteKey, true);
  } catch (error) {
    if (!error || error.code !== "app-check/already-initialized") {
      throw error;
    }
  }

  appCheckActivated = true;
}

export function getFirebaseApp() {
  if (!isFirebaseConfigured()) {
    return null;
  }

  if (firebase.apps.length === 0) {
    firebase.initializeApp(config.firebase);
  }

  activateAppCheck();
  return firebase.app();
}

export function getFirestore() {
  return getFirebaseApp() ? firebase.firestore() : null;
}

export function getFirebaseAuth() {
  return getFirebaseApp() ? firebase.auth() : null;
}

export function getServerTimestamp() {
  return firebase.firestore.FieldValue.serverTimestamp();
}
